module.exports = __webpack_public_path__ + "media/images/icons/vendors/paperthings-f9d53f067f342552bb68375b49eb270c.png";